import React from "react";
import { Input as OriginInput } from "reactstrap";
import { classnames } from "../../utils/text";
const Input = ({
  name,
  type = "text",
  placeholder,
  onKeyPress = () => { },
  onKeyUp = () => { },
  onKeyDown = () => { },
  value,
  defaultValue,
  maxLength,
  onChange = () => { },
  disabled,
  className,
  textAlign,
  readOnly,
  isDisabled,
  isHide,
  ...props
}) => {
  return (
    <>
      <OriginInput
        style={{ textAlign: textAlign }}
        // className={classnames("component-input", className)}
        className={classnames("component-input print-out", className)}
        name={name}
        type={type}
        placeholder={placeholder}
        onKeyPress={onKeyPress}
        onKeyDown={onKeyDown}
        onKeyUp={onKeyUp}
        value={value}
        onChange={onChange}
        disabled={disabled}
        readOnly={readOnly}
        {...props}
      />
      <span
        style={{ textAlign, display: "none" }}
        className={classnames("input-print print-in-inline-block", className)}>
        {value || ""}
      </span>
    </>
  );
};
export default Input;
